export default __webpack_public_path__ + "96bf8e1482a5971ecaac83d5710ef6d5.jpg";